export default __webpack_public_path__ + "static/media/liga-jabar-poster.79db8cc6.png";